import styled from "styled-components";

export const SectionCard = styled.section`
  width: 100%;
  background-color: var(--bg-100);
  border-radius: var(--border-radius-large);
  box-shadow: var(--shadow-small);
  border: 1px solid var(--bg-200);
  margin-bottom: var(--spacing-lg);
  overflow: hidden;
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  padding: var(--spacing-md) var(--spacing-lg);
  background-color: var(--bg-200);
`;

export const StepBadge = styled.div`
  flex-shrink: 0;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-size-small);
  font-weight: 600;
  background-color: ${(props) =>
    props.$done ? "var(--success-color)" : "var(--primary-100)"};
  color: var(--bg-100);
  transition: background-color var(--transition-fast);
`;

export const SectionTitle = styled.h2`
  margin: 0;
  font-size: var(--font-size-base);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-100);
  flex: 1;
`;

export const SectionSubtitle = styled.span`
  font-size: var(--font-size-small);
  color: var(--text-200);
  font-weight: 400;
  text-transform: none;
  letter-spacing: normal;
`;

export const SectionBody = styled.div`
  padding: var(--spacing-lg);
`;

const CheckIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
    <path
      d="M5 12.5L10 17.5L19 7.5"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const StepBadgeContent = ({ step, done }) => (done ? <CheckIcon /> : step);
